export const TableHeader = (t) => [
  {
    title: t("labels.country.regulatorList.regulatorTable.headers.country"),
    field: "country_name",
    editable: "never",
  },
  {
    title: t("labels.country.regulatorList.regulatorTable.headers.regulatorCode"),
    field: "regulator_code",
  },
  {
    title: t("labels.country.regulatorList.regulatorTable.headers.regulatorName"),
    field: "regulator_name",
  },
  {
    title: t("labels.country.regulatorList.regulatorTable.headers.equivalent"),
    field: "is_equivalent",
    lookup: { true: t("labels.common.yes"), false: t("labels.common.no") },
  },
];
